/**
 * @author Ehsan Elahi
 */

import React from "react";
import { connect } from 'react-redux';

import { Field } from "redux-form";
import Table from "react-table";
import * as BS from "react-bootstrap";
import "react-table/react-table.css";
import _ from 'lodash';
import { toast } from "react-toastify";

import withFixedColumns from 'react-table-hoc-fixed-columns';
import 'react-table-hoc-fixed-columns/lib/styles.css'

import FormProvider from "../../components/FormProvider";
import ActionsCell from "../../components/ActionCell";
import HighlightCell from "../../components/HighlightCell";
import GridFilters from "../../components/GridFilter";
import ErrorBoundary from "../../components/ErrorBoundary";
import Permission from '../../utils/Permission';

import { getShelfLives, updateShelfLife, deleteShelfLife, addShelfLife } from '../../../actions/Basic_data/shelflife_actions';
import { element } from "prop-types";

const ReactTableFixedColumns = withFixedColumns(Table);

class ShelfLife extends React.Component {

    temperatureUnitData = [
        { '_id': 'Celsius', 'name': 'Celsius' },
        { '_id': 'Fahrenheit', 'name': 'Fahrenheit' }
    ];

    state = {
        shelfLives: [],
        state: '',
        temperatureUnit: '',
        temperature: '',
        slug: '',
        editing: null,
        deleting: null,
        sortOptions: [{ id: 'state', desc: false }],
    };

    componentDidMount() {
        this.props.getShelfLives(this.props.token);
    }

    editableComponent = ({ input, editing, value, ...rest }) => {
        const Component = editing ? BS.FormControl : BS.FormControl.Static;
        const children =
            (!editing && <HighlightCell value={value} {...rest} />) || undefined;
        return <Component {...input} {...rest} children={children} />;
    };

    editableColumnProps = {
        ...GridFilters,
        Cell: props => {
            const editing = this.state.editing === props.original;
            const fieldProps = {
                component: this.editableComponent,
                editing,
                props
            };

            return <Field name={props.column.id} {...fieldProps} />;
        }
    };

    selectableColumnProps = {
        ...GridFilters,
        Cell: props => {
            const editing = this.state.editing === props.original;
            const fieldProps = {
                component: this.renderDropdownList,
                editing,
                props
            };

            return (editing ? <Field name={props.column.id} component="select" className='form-control' defaultValue={props.value} onBlur={e => this.setStateForEdit(props.column.Header, e.target.value)}>
                {this.temperatureUnitData.map(data =>
                    <option key={data._id} value={data._id}>{data.name}</option>
                )}
            </Field> : <label>{props.value}</label>)
        }
    };

    setStateForEdit = (column, value) => {
        if (column === 'Temperature Unit') {
            this.setState({ temperatureUnit: value })
        }
    }

    editableSelectComponent = ({ input, editing, value, ...rest }) => {
        const Component = editing ? BS.DropdownButton : BS.FormControl.Static;
        const children =
            (!editing && <HighlightCell value={value} {...rest} />) || undefined;
        return <Component {...input} {...rest} children={children} />;
    };

    getActionProps = (gridState, rowProps) =>
        (rowProps && {
            mode: this.state.editing === rowProps.original ? "edit" : "view",
            actions: {
                onEdit: () => {
                    this.setState({
                        editing: rowProps.original
                    })
                },
                onCancel: () => this.setState({ editing: null }),
                onDelete: () => {
                    this.setState({ deleting: rowProps.original })
                }
            },
            updPerm: Permission('BASIC DATA', 'SHELFLIFE', 'UPDATE', this.props),
            delPerm: Permission('BASIC DATA', 'SHELFLIFE', 'DELETE', this.props)
        }) ||
        {};

    handleSubmit = values => {
        if (this.state.deleting === null && this.state.editing !== null) {
            var data = values;

            this.props.updateShelfLife(data, this.props.token)

        } else if (this.state.deleting !== null && this.state.editing === null) {
            var data = {
                '_id': values._id
            }

            this.props.deleteShelfLife(data, this.props.token)
        }
    };

    addShelfLifeHandle = () => {
        var { state, temperatureUnit, temperature } = this.state;

        if (state.trim() !== '' || temperatureUnit.trim() !== '' || temperature.trim() !== '') {

            this.state.slug = state.replace(/ /gi, "-");
            this.state.slug = this.state.slug.replace(/'/gi, "-");

            this.props.addShelfLife(this.state, this.props.token)

            this.setState({
                state: '',
                temperatureUnit: '',
                temperature: '',
                slug: '',
            });

            document.getElementById("addShelfLifeForm").reset();
        } else {
            toast.error('Please fill up the mandatory fields!')
        }
    }

    filterCaseInsensitive = (filter, row) => {
        const id = filter.pivotId || filter.id;
        return (
            row[id] !== undefined ?
                String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                :
                true
        );
    }

    shelfLifeColumns = [
        { Header: "State", accessor: "state", ...this.editableColumnProps },
        { Header: "Temperature Unit", accessor: "temperatureUnit", ...this.selectableColumnProps },
        { Header: "Temperature", accessor: "temperature", ...this.editableColumnProps, getProps: () => { return { style: { 'text-align': 'right' } } } },
        {
            Header: "Actions",
            fixed: 'right',
            maxWidth: 130,
            minWidth: 130,
            filterable: false,
            getProps: this.getActionProps,
            Cell: ActionsCell
        },
    ];

    render() {
        return (
            <div className="right_col" role="main">
                <div className="card">
                    <div className="card-header">
                        <button className="btn btn-primary" disabled={Permission('BASIC DATA', 'SHELFLIFE', 'ADD', this.props)} data-toggle="modal" data-target="#addShelfLife">+ ShelfLife</button>
                    </div>
                    <div className="card-body">
                        <React.Fragment>
                            <ErrorBoundary>
                                <FormProvider
                                    form="inline"
                                    onSubmit={this.handleSubmit}
                                    onSubmitSuccess={() => this.setState({ editing: null, deleting: null })}
                                    initialValues={this.state.editing === null ? this.state.deleting : this.state.editing}
                                    enableReinitialize
                                >
                                    {formProps => {
                                        return (
                                            <form onSubmit={formProps.handleSubmit}>
                                                <ReactTableFixedColumns className="-striped"
                                                    sorted={this.state.sortOptions}
                                                    onSortedChange={val => {
                                                        this.setState({ sortOptions: val })
                                                    }}
                                                    columns={this.shelfLifeColumns}
                                                    data={this.props.shelfLives}
                                                    defaultPageSize={10}
                                                    defaultFilterMethod={this.filterCaseInsensitive}
                                                    showPageJump={false}
                                                />
                                            </form>
                                        );
                                    }}
                                </FormProvider>
                            </ErrorBoundary>
                        </React.Fragment>
                    </div>


                    <div id="addShelfLife" className="modal fade" role="dialog">
                        <div className="modal-dialog">
                            <div className="modal-content animate" >
                                <div className="modal-header">
                                    <h4 className="modal-title text-uppercase">Add Delivery Condition</h4>
                                    <button type="button" className="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div className="modal-body">
                                    <React.Fragment>
                                        <form id='addShelfLifeForm'>
                                            <table>
                                                <tbody>

                                                    <tr>
                                                        <td>State* :</td>
                                                        <td><input type="text" className="form-control" onBlur={e => this.setState({ state: e.target.value })} /></td>
                                                    </tr>

                                                    <tr>
                                                        <td>Temperature Unit* :</td>
                                                        <td>
                                                            <select className="form-control" onBlur={e => e.target.value === '' ? null : this.setState({ temperatureUnit: e.target.value })}>
                                                                <option value={''}>- Select Temperature Unit -</option>
                                                                {this.temperatureUnitData.map(element => {
                                                                    return <option value={element._id}>{element.name}</option>
                                                                })}
                                                            </select>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td>Temperature* :</td>
                                                        <td><input type="number" className="form-control" onBlur={e => this.setState({ temperature: e.target.value })} /></td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </form>
                                    </React.Fragment>
                                </div>
                                <div className="modal-footer">
                                    <button id="add_stock" type="button" className="btn btn-primary" onClick={this.addShelfLifeHandle}>Add</button>
                                    {/* <Button id='add_supplier' click={this.props.addSupplier(this.state, this.props.token)} value={'add'}/> */}
                                    <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="card-footer"></div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        token: state.rLogin.token,
        shelfLives: state.rShelfLife.shelfLives,
        userProgramme: state.rLogin.programme,
        programme: state.rPermission.programme,
        subProgramme: state.rPermission.subProgramme,
        options: state.rPermission.option
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getShelfLives: (token) => { dispatch(getShelfLives(token)) },
        updateShelfLife: (data, token) => { dispatch(updateShelfLife(data, token)) },
        deleteShelfLife: (data, token) => { dispatch(deleteShelfLife(data, token)) },
        addShelfLife: (data, token) => { dispatch(addShelfLife(data, token)) },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShelfLife);


